import { useEffect, useRef, useState } from "react";

// Components
import { userState, lastSelectedPeriod, lastSelectedCategory, lastSelectedKeywordsCookieID } from "../../interface/MainInterface";
import TopBanner from "./articles/TopBanner";
import KeywordNavigation from "./articles/KeywordNavigation";
import SearchNavigation from "./articles/SearchNavigation";
import BriefList from "./articles/BriefList";

// CSS
import "./Aitb.css";

interface propsType {
  userState: userState;
  briefList: any;
  setBriefList: any;
  selectedPeriod: string;
  setSelectedPeriod: any;
  lastEvalKey: any;
  setLastEvalKey: any;
  nowPageSize: number;
  setNowPageSize: any;
  lastScrollPos: number;
  setLastScrollPos: any;
  needRefresh: boolean;
  setNeedRefresh: any;
}

const Aitb = (props: propsType) => {
  const briefListRef: any = useRef();
  const [selectedKeywords, setSelectedKeywords] = useState<any>([]);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  useEffect(() => {
    if (!props.userState.isAuth) window.location.href = "/signin";

    // 사용자의 마지막 선택 카테고리를 세팅
    const cookieLastCategory: any = window.localStorage.getItem(lastSelectedCategory);
    if (cookieLastCategory !== "undefined" && cookieLastCategory !== "" && cookieLastCategory !== null) {
      setSelectedCategory(JSON.parse(cookieLastCategory));
    }

    // 사용자의 마지막 선택 키워드를 세팅
    const cookieLastKeywords: any = window.localStorage.getItem(lastSelectedKeywordsCookieID);
    if (cookieLastKeywords !== undefined && cookieLastKeywords !== "" && cookieLastKeywords !== null) {
      // console.log("useEffect cookieLastKeywords ", cookieLastKeywords);
      if (props.needRefresh) {
        // 뒤로가기가 아닐때는 초기화 하자.
        window.localStorage.setItem(lastSelectedKeywordsCookieID, "");
      } else {
        setSelectedKeywords([cookieLastKeywords]);
      }
    }
    return () => {
      setSelectedKeywords(null);
      setSelectedCategory("");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {props.userState.isAuth && (
        <section id="commWrap">
          <TopBanner callback={(payload: any) => {}} />
          <KeywordNavigation
            selectedPeriod={props.selectedPeriod}
            selectedCategory={selectedCategory}
            selectedKeywords={selectedKeywords}
            callback={(payload: any) => {
              if (payload.command === "selected_keyword") {
                setSelectedKeywords(payload.value);
                // 사용자가 마지막으로 선택했던 키워드 목록을 쿠키에 저장하고 페이지 다시 돌아올 때 초기 세팅값으로 재사용한다.
                window.localStorage.setItem(lastSelectedKeywordsCookieID, payload.value);
              }
            }}
          />
          <SearchNavigation
            selectedPeriod={props.selectedPeriod}
            selectedCategory={selectedCategory}
            callback={(payload: any) => {
              if (payload.command === "selected_period") {
                props.setSelectedPeriod(payload.value);
                window.localStorage.setItem(lastSelectedPeriod, payload.value);
              } else if (payload.command === "selected_category") {
                setSelectedCategory(payload.value);
                window.localStorage.setItem(lastSelectedCategory, JSON.stringify(payload.value));
              }
            }}
          />
          <BriefList
            ref={briefListRef}
            userState={props.userState}
            selectedPeriod={props.selectedPeriod}
            selectedKeywords={selectedKeywords}
            selectedCategory={selectedCategory}
            queryText=""
            searchText=""
            setSearchText={() => {}}
            briefList={props.briefList}
            setBriefList={props.setBriefList}
            lastEvalKey={props.lastEvalKey}
            setLastEvalKey={props.setLastEvalKey}
            nowPageSize={props.nowPageSize}
            setNowPageSize={props.setNowPageSize}
            lastScrollPos={props.lastScrollPos}
            setLastScrollPos={props.setLastScrollPos}
            needRefresh={props.needRefresh}
            setNeedRefresh={props.setNeedRefresh}
            callback={(payload: any) => {}}
          />
        </section>
      )}
    </>
  );
};

export default Aitb;
